// Lib
import gql from 'graphql-tag';

// Queries
import { THREAD_MESSAGE_FIELDS } from '../queries/threads';

/* Live feed for every thread of the current org (org messaging): messages
 * (created / delivery updates) and my account's read state. Not an ADR-009
 * envelope: consumers refetch their snapshot on WS reconnect (and on a
 * RESYNC_REQUIRED error) and dedupe messages by `_id`. */
export const threadEventsSubscription = gql`
  subscription ThreadEvents {
    threadEvents {
      kind
      threadId
      unreadCount
      message {
        ${THREAD_MESSAGE_FIELDS}
      }
    }
  }
`;
